/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  RunScriptResult,
  DeployContractExecutionResult,
  NetworkId,
} from "@alephium/web3";
import {
  Pool,
  PoolInstance,
  Position,
  PositionInstance,
  Tick,
  TickInstance,
  BitmapWord,
  BitmapWordInstance,
  PoolConfig,
  PoolConfigInstance,
  DexAccount,
  DexAccountInstance,
  PoolFactory,
  PoolFactoryInstance,
  PositionManager,
  PositionManagerInstance,
} from ".";
import { default as testnetDeployments } from "../../deployments/.deployments.testnet.json";
import { default as devnetDeployments } from "../../deployments/.deployments.devnet.json";

export type Deployments = {
  deployerAddress: string;
  contracts: {
    Pool: DeployContractExecutionResult<PoolInstance>;
    Position: DeployContractExecutionResult<PositionInstance>;
    Tick: DeployContractExecutionResult<TickInstance>;
    BitmapWord: DeployContractExecutionResult<BitmapWordInstance>;
    PoolConfig: DeployContractExecutionResult<PoolConfigInstance>;
    DexAccount: DeployContractExecutionResult<DexAccountInstance>;
    PoolFactory: DeployContractExecutionResult<PoolFactoryInstance>;
    PositionManager: DeployContractExecutionResult<PositionManagerInstance>;
  };
  scripts: {
    CreateConfig_CreateConfig0: RunScriptResult;
    CreateConfig_CreateConfig1: RunScriptResult;
    CreateConfig_CreateConfig2: RunScriptResult;
    CreateConfig_CreateConfig3: RunScriptResult;
    CreateConfig_CreateConfig4: RunScriptResult;
    CreateConfig_CreateConfig5: RunScriptResult;
    CreateConfig_CreateConfig6: RunScriptResult;
    CreateConfig_CreateConfig7: RunScriptResult;
    CreateConfig_CreateConfig8: RunScriptResult;
    CreateConfig_CreateConfig9: RunScriptResult;
  };
};

function toDeployments(json: any): Deployments {
  const contracts = {
    Pool: {
      ...json.contracts["Pool"],
      contractInstance: Pool.at(
        json.contracts["Pool"].contractInstance.address
      ),
    },
    Position: {
      ...json.contracts["Position"],
      contractInstance: Position.at(
        json.contracts["Position"].contractInstance.address
      ),
    },
    Tick: {
      ...json.contracts["Tick"],
      contractInstance: Tick.at(
        json.contracts["Tick"].contractInstance.address
      ),
    },
    BitmapWord: {
      ...json.contracts["BitmapWord"],
      contractInstance: BitmapWord.at(
        json.contracts["BitmapWord"].contractInstance.address
      ),
    },
    PoolConfig: {
      ...json.contracts["PoolConfig"],
      contractInstance: PoolConfig.at(
        json.contracts["PoolConfig"].contractInstance.address
      ),
    },
    DexAccount: {
      ...json.contracts["DexAccount"],
      contractInstance: DexAccount.at(
        json.contracts["DexAccount"].contractInstance.address
      ),
    },
    PoolFactory: {
      ...json.contracts["PoolFactory"],
      contractInstance: PoolFactory.at(
        json.contracts["PoolFactory"].contractInstance.address
      ),
    },
    PositionManager: {
      ...json.contracts["PositionManager"],
      contractInstance: PositionManager.at(
        json.contracts["PositionManager"].contractInstance.address
      ),
    },
  };
  return {
    ...json,
    contracts: contracts as Deployments["contracts"],
    scripts: {
      CreateConfig_CreateConfig0: json.scripts["CreateConfig:CreateConfig0"],
      CreateConfig_CreateConfig1: json.scripts["CreateConfig:CreateConfig1"],
      CreateConfig_CreateConfig2: json.scripts["CreateConfig:CreateConfig2"],
      CreateConfig_CreateConfig3: json.scripts["CreateConfig:CreateConfig3"],
      CreateConfig_CreateConfig4: json.scripts["CreateConfig:CreateConfig4"],
      CreateConfig_CreateConfig5: json.scripts["CreateConfig:CreateConfig5"],
      CreateConfig_CreateConfig6: json.scripts["CreateConfig:CreateConfig6"],
      CreateConfig_CreateConfig7: json.scripts["CreateConfig:CreateConfig7"],
      CreateConfig_CreateConfig8: json.scripts["CreateConfig:CreateConfig8"],
      CreateConfig_CreateConfig9: json.scripts["CreateConfig:CreateConfig9"],
    },
  };
}

export function loadDeployments(
  networkId: NetworkId,
  deployerAddress?: string
): Deployments {
  const deployments =
    networkId === "testnet"
      ? testnetDeployments
      : networkId === "devnet"
      ? devnetDeployments
      : undefined;
  if (deployments === undefined) {
    throw Error("The contract has not been deployed to the " + networkId);
  }
  const allDeployments: any[] = Array.isArray(deployments)
    ? deployments
    : [deployments];
  if (deployerAddress === undefined) {
    if (allDeployments.length > 1) {
      throw Error(
        "The contract has been deployed multiple times on " +
          networkId +
          ", please specify the deployer address"
      );
    } else {
      return toDeployments(allDeployments[0]);
    }
  }
  const result = allDeployments.find(
    (d) => d.deployerAddress === deployerAddress
  );
  if (result === undefined) {
    throw Error("The contract deployment result does not exist");
  }
  return toDeployments(result);
}
